// extracted by mini-css-extract-plugin
export default {"buttons":"Buttons-module__buttons--r0nB1"};